import React, { CSSProperties } from 'react';
import { FeatureMetric, FeatureStatistics } from '@models/feature';
import { Localize, Unset } from '@utils';

const metricRowStyle: CSSProperties = {
  borderTop: '1px solid var(--c-grey-100)',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingInlineEnd: '50px',
  height: '30px',
};

const metricNameStyle: CSSProperties = {
  textTransform: 'capitalize',
};

const statsOrder = [
  FeatureMetric.Min,
  FeatureMetric.Max,
  FeatureMetric.Mean,
  FeatureMetric.Stddev,
  FeatureMetric.Count,
  FeatureMetric.NullRatio,
  FeatureMetric.ZerosRatio,
  FeatureMetric.Correlation,
  FeatureMetric.FeatureAUC,
];

export const FeatureStatisticsTable: React.FC<{
  statistics: FeatureStatistics;
}> = ({ statistics }) => {
  return (
    <div style={{ columnCount: 2, columnFill: 'balance', columnGap: '60px' }}>
      {(Object.entries(statistics) as [FeatureMetric, number | Unset][])
        .sort(sortStatsByName)
        .map(([metricName, metricValue]) => (
          <div key={metricName} style={metricRowStyle}>
            <span className="label-bold" style={metricNameStyle}>
              {metricName}
            </span>{' '}
            <span>{Localize.formatNumber(metricValue, '-')}</span>
          </div>
        ))}
    </div>
  );
};

function sortStatsByName(
  a: [FeatureMetric, number | Unset],
  b: [FeatureMetric, number | Unset]
): number {
  return statsOrder.indexOf(a[0]) - statsOrder.indexOf(b[0]);
}
